import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import { GET_RETRIEVE_AUDIT_SETTINGS_URL } from '../../constants/apiUrls';
import { GET_RETRIEVE_AUDIT_SETTINGS_QUERY_KEY } from '../../constants/queryKeys';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// ===========================================================================

export interface RetrieveAuditSettingsResponse {
  uuid: string;
  firstGeneratedDate: string;
  repeat: string;
  reviewDeadLine: number;
  reminderReviewRepeat: string;
  lastUpdatedBy: string;
  lastUpdatedDateTime: string;
}

interface Input {
  reportType: string;
  onSuccess: (data: RetrieveAuditSettingsResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetRetrieveAuditSettings = ({ onSuccess, onError, reportType }: Input) => {
  const getRetrieveAuditSettings = async () => {
    const res = await axiosClient.get<RetrieveAuditSettingsResponse>(
      GET_RETRIEVE_AUDIT_SETTINGS_URL(reportType)
    );
    return res.data;
  };

  return useCustomQuery(GET_RETRIEVE_AUDIT_SETTINGS_QUERY_KEY, getRetrieveAuditSettings, {
    onSuccess,
    onError,
  });
};
